var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerksMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-perks-megaphone_svg__clip0_690_4776)",
    stroke: "#000",
    strokeWidth: 2.081,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.237 11.872l41.985-9.56v26.376l-41.985-9.56v-7.256z",
    fill: "#FCEA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.284 21.496c-.073 2.384 1.167 4.465 3.027 5.15 2.1.776 4.577-.382 5.778-2.796M49.346 15.5h10.758M49.88 8.901l7.605-7.605M49.363 22.1l7.605 7.604"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-perks-megaphone_svg__clip0_690_4776"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h61.34v31H0z"
  })))));
}
export default SvgIconPerksMegaphone;